import { render, staticRenderFns } from "./Discount‌Price.vue?vue&type=template&id=0998eb10"
import script from "./Discount‌Price.vue?vue&type=script&lang=js"
export * from "./Discount‌Price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports